import { ColumnTypeEnum } from '../base-column/column-type-enum';
import { Column, ColumnConfig, IColumn } from '../base-column/column.model';
import { ColumnClassProperties } from '../common-models/class.model';
import {
  initFromConfigButton,
  initFromPropsButtons,
} from '../common-models/init-functions';
import { styleProperties } from '../common-models/style.model';
import { Button } from './common/button.model';

export class ButtonColumn<T>
  extends Column<T>
  implements IColumn<T>, Button<T>
{
  isVisibleAction?: (item?: T) => boolean;
  isDisabledAction?: (item?: T) => boolean;

  constructor(config: ColumnConfig<T>);
  constructor(
    title?: string,
    icon?: string | ((item?: any) => string),
    styleClass?: string | ((item?: any) => string),
    style?: styleProperties,
    pTooltip?: string | ((item?: any) => string),
    tooltipPosition?: string,
    action?: (item?: T, event?: any) => any,
    isVisibleAction?: (item?: T) => boolean,
    isDisabledAction?: (item?: T) => boolean
  );
  constructor(
    titleOrConfig?: ColumnConfig<T> | string,
    icon?: string | ((item?: any) => string),
    styleClass?: string | ((item?: any) => string),
    style?: styleProperties,
    pTooltip?: string | ((item?: any) => string),
    tooltipPosition?: string,
    action?: (item?: T, event?: any) => any,
    isVisibleAction?: (item?: T) => boolean,
    isDisabledAction?: (item?: T) => boolean
  ) {
    super();
    if (typeof titleOrConfig === 'object') {
      const config = titleOrConfig as ColumnConfig<T>;
      initFromConfigButton(this, config);
    } else {
      initFromPropsButtons(
        this,
        titleOrConfig,
        icon,
        styleClass,
        style,
        pTooltip,
        tooltipPosition,
        action,
        isVisibleAction,
        isDisabledAction
      );
    }
  }

  GetSort(): boolean {
    return false;
  }

  GetTooltip(): string | ((item?: any) => string) {
    return this.Tooltip ?? null;
  }

  GetPropertyName(): string {
    return this.PropertyName ?? 'null';
  }

  GetName(): string {
    return this.Name ?? '';
  }
  //Θα επιστρέφει το αντίστοιχο entry από το Enum για DateColumn
  GetColumnType(): string {
    return ColumnTypeEnum.ButtonColumn;
  }

  //Θα πρέπει να επιστρέφει το value που θα εμφανιστεί στο grid βασισμένο στο Propertyname μετά από τους μετασχηματισμούς.
  //Για την υποστήριξη των nested object θα πρέπει να υπάρχει split και recursive αναζήτηση των properties.
  GetValue(obj?: string): string {
    return obj ?? '';
  }

  GetColumnClassProperties(): ColumnClassProperties {
    return this.ColumnClassProperties ?? {};
  }

  GetAction(row: T, event?: any): any {
    if (this.Action) {
      return this.Action(row, event);
    } else {
      throw new Error('Action is not defined in button model.');
    }
  }

  GetIsDisabled(row?: T | undefined): boolean {
    if (this.isDisabledAction) {
      return this.isDisabledAction(row);
    } else {
      return false;
    }
  }

  GetIsVisible(row?: T | undefined): boolean {
    if (this.isVisibleAction) {
      return this.isVisibleAction(row);
    } else {
      return true;
    }
  }
}
